
export function querySearchText(searchText, isSearchFromStartOfString = true) {
  return { $regex: `${isSearchFromStartOfString ? '^' : ''}${searchText}`, $options: 'i' }
}

export function truncate(str, n){
  return (str.length > n) ? str.substr(0, n-1) + '...' : str;
}



// WEBPACK FOOTER //
// ./src/utils/query.js